import { Location } from "@angular/common";
import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import * as RouterActions from "../actions/router.action";

@Injectable()
export class RouterEffects {
    constructor(private actions$: Actions, private router: Router, private location: Location, private ngZone: NgZone) {}

    navigate$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RouterActions.routerGo),
                tap(({ path, query: queryParams, extras }) => {
                    this.ngZone.run(() => {
                        this.router
                            .navigate(path, {
                                ...extras,
                                queryParams,
                            })
                            .catch(_ => null);
                    });
                })
            ),
        { dispatch: false }
    );

    navigateBack$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RouterActions.routerBack),
                tap(() => this.location.back())
            ),
        { dispatch: false }
    );

    navigateForward$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RouterActions.routerForward),
                tap(() => this.location.forward())
            ),
        { dispatch: false }
    );
}
